import { useNavigate } from 'react-router-dom'
import { Safety } from '../classes/Safety'
import { LoginResponse } from '../types/auth'
import { User } from '../types/models'
import { useApp } from './useApp'
import { callAxios } from './useAxios'
import { useDevices } from './useDevices'

/**
 * A pass through hook to store and retrieve a token from the local storage.
 */
export const useAuth = () => {

  const app = useApp()
  const { setDevices } = useDevices()
  const navigate = useNavigate()

  async function updateMe(): Promise<LoginResponse | undefined> {
    return callAxios<LoginResponse>({
      url: '/auth/me',
    }).then(res => {
      if (res.success) {
        const user: User = { ...res.data.user, features: res.data.features, announcements: res.data.announcements }
        app.setUser(user)
        app.setLocations(res.data.locations)
        setDevices(res.data.devices)
        return res.data
      } else if (Safety.get('user')) {
        // A 401 has wiped the session meanwhile; that is handled, not an error to show.
        app.addError(res)
      }
    })
  }

  async function login(res: LoginResponse): Promise<void> {
    Safety.setVersion()
    Safety.set('refresh_token', res.refresh_token)
    Safety.set('token', res.token)
    const data = await updateMe()
    if (data) {
      if (data.user.language !== Safety.get('language')) {
        Safety.set('language', data.user.language)
        document.location = '/'
      } else {
        navigate('/')
      }
    }
  }

  return {
    updateMe,
    login,
  }
}
